import React from "react"
import { useIntl } from "../hooks"
import { Footer, Navbar, TopBanner } from "."
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

interface Props {
  children: React.ReactNode
  hasBanner?: boolean
}

export default function Layout({ children, hasBanner = true }: Props) {
  const { t } = useIntl()

  const data = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "socialie+photoshelter.png" }) {
        id
        childImageSharp {
          fluid(maxWidth: 204) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <div className="overflow-hidden">
      {hasBanner && (
        <TopBanner link="https://stories.photoshelter.com/photoshelter-acquires-socialie/">
          <div className="container flex items-center justify-center z-50 text-white text-small tablet:text-16 laptop:text-16 tracking-12">
            {data?.image && <Img fluid={data?.image.childImageSharp.fluid} className="w-7.5 mr-2" />}
            <span className="flex-1 leading-tight text-left">{t("TopBanner__Copy")}</span>
            <span className="underline ml-3 flex-shrink-0">{t("TopBanner__Button")}</span>
          </div>
        </TopBanner>
      )}
      <Navbar />
      {children}
      <Footer />
    </div>
  )
}
